// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"162":"9ac34292","502":"a00d872a","845":"b7c953b3"}[chunkId] + ".chunk.js";
};